import React, { useContext, useEffect, useState } from 'react';
import UserContext from '@/context/UserContext';
import { isJaguar } from '@/utility/UserUtils';
import { format } from 'date-fns';
import { fetchAPI } from '@/utility/NetworkUtils';
const OrderUpdatedAtComponent = ({order}) => {
  const { user } = React.useContext(UserContext);
  const [ createdBy, setCreatedBy ] = useState(null);
  const [ updatedBy, setUpdatedBy ] = useState(null);
  const [ loading, setLoading ] = useState(true);
  const fetchWhodunnit = () => {
    setLoading(true)
    fetchAPI(`/webapi/orders/${order.id}/whodunnit`, (json) => {
      setLoading(false)
      if (!json.error) {
        setUpdatedBy(json.updated_by)
        setCreatedBy(json.created_by)
      } else {

      }
    })
  }

  useEffect(() => {
    if(isJaguar(user)){
      fetchWhodunnit()
    }
  }, [user, order?.id]);

  const renderUser = (renderingUser) => {
    if(loading) {
      return "[Loading...]"
    }
    else if(renderingUser) {
      return `${renderingUser.first_name} ${renderingUser.last_name}`
    }else {
      return "[Unknown]"
    }
  }
  console.log({
    order
  })
  if(isJaguar(user) && order){
    return (
      <div className="quickview-additional-info align-baseline mt-auto mb-[20px]">
        Last Updated by: {renderUser(updatedBy)}, {format(new Date(order.updated_at), "MM/dd/yyyy, h:mm a")}
      </div>
    )
  }
}
export default OrderUpdatedAtComponent